/**
 * 导航栏
 * @author jean
 * @time 2021/11/18
 * 使用方法：
 */

import React, { Component } from 'react';
import { Flex, Modal, Toast } from 'antd-mobile';
import { inject } from 'mobx-react';
import cx from 'classnames';
import Util from 'utils';
import Config from 'config/Config';
import Request from 'utils/request';
import PropTypes from 'prop-types';
import styles from './index.modules.less';
import CommonBtn from 'pubBiz/CommonBtn/CommonBtnView';
import copy from 'copy-to-clipboard';

@inject('AppMod')
class CardOpenTip extends Component {
  static propTypes = {
    shouldSupply: PropTypes.bool // 是否显示完善资料按钮
  };

  static defaultProps = {
    shouldSupply: true
  };

  constructor(props, context) {
    super(props, context);
    this.stores = this.props.AccoumulateMod;
    const { upgrate } = this.props;
    this.state = {
      showModal: false,
      footer: []
    };
  }

  componentDidMount() {
    this.updateFooter();

    Request({
      url: 'user/info/getUserShouldSupply',
      host: Config.HOST_MALL,
      method: 'get'
    }).then(({ data }) => {
      const { memberUserInfo, shouldSupply } = this.props;
      const { cardCode } = memberUserInfo || {};
      const { userInfo = {} } = this.props.AppMod || {};

      const { footer } = this.state;

      if (!!data && cardCode == userInfo.cardCode && shouldSupply) {
        if (!footer.some((item) => item.text === '完善资料')) {
          footer.unshift({
            text: '完善资料',
            className: styles.btn,
            onPress: () => {
              window.app.routerGoTo({
                pathname: '/personal/msgAdd',
                state: {
                  applyType: 3,
                  data: {
                    localCardCode: cardCode,
                    accumulate: 1
                  }
                }
              });
            }
          });
          this.setState({
            footer
          });
        }
      }
    });
  }

  updateFooter() {
    const { upgrate, memberUserInfo } = this.props;
    const { cardCode, realName, password: cardPasswords, payPassword } = memberUserInfo || {};
    let registerMember_Info = Util.getLocalCache('registerMember_Info') || {};
    const { userPassValue: newUserPassValue, payPassword: newPayPassword } =
      registerMember_Info || {};

    let cardPassword = cardPasswords || newUserPassValue || '';
    let cardPayPassword = payPassword || newPayPassword || '';

    const footer = [
      {
        text: '关闭',
        className: cx(styles.btn, styles.regular),
        onPress: () => {
          if (this.props.callback) {
            this.props.callback();
          } else {
            window.app.router.goBack();
          }
        }
      }
    ];

    if (cardPassword) {
      footer.unshift({
        text: '一键复制',
        className: cx(styles.btn),
        onPress: () => {
          let cardCodeValue = cardCode || '';
          let realNameValue = realName || '';

          let content = [];
          content.push(`会员卡号：${cardCodeValue}`);
          content.push(`登录密码：${cardPassword}`);
          if (cardPayPassword) content.push(`会员支付密码：${cardPayPassword}`);
          if (realNameValue) content.push(`会员姓名：${realNameValue}`);
          if (copy(content.join('\n'))) {
            Toast.info('复制成功');
          } else {
            Toast.info('复制失败');
          }
        }
      });
    }

    this.setState({ footer });
  }

  componentWillUnmount() {
    // 清除注册缓存
    Util.setLocalCache('registerMember_Info', '');
  }

  renderUserModal() {
    const { footer } = this.state;
    const { upgrate, memberUserInfo } = this.props;
    const {
      cardCode,
      cardTypeName,
      realName,
      createTime: registerTime,
      password: cardPasswords,
      payPassword
    } = memberUserInfo || {};
    let cardCodeValue = cardCode;
    let realNameValue = realName;
    let registerTimeValue = registerTime;
    let cardTypeText = cardTypeName;
    let cardPassword = cardPasswords;

    let registerMember_Info = Util.getLocalCache('registerMember_Info') || {}; // 注册信息
    const {
      registerTime: newRegisterTime,
      userPassValue: newUserPassValue,
      payPassword: newPayPassword
    } = registerMember_Info || {};

    return (
      <Modal
        className={styles.registerSuccModal}
        visible={!!memberUserInfo}
        transparent
        maskClosable={false}>
        <Flex direction="column" justify="center" align="center" className={styles.registerSuccBox}>
          <div className={styles.infoGroup}>
            <span className={cx('iconfont', 'icon-Successful', styles.icon)} />
            <div className={styles.headerContainer}>
              <div className={styles.mainTitle}>{upgrate ? '恭喜升级成功' : '恭喜你注册成功'}</div>
              <div className={styles.subTitle}>{'您的账号信息如下'}</div>
            </div>

            <div className={styles.contentList}>
              {cardTypeText && (
                <Flex justify="between" align="start" className={styles.itemRow}>
                  <span className={styles.label}>会员等级</span>
                  <span className={styles.value}>{cardTypeText}</span>
                </Flex>
              )}
              <Flex justify="between" align="start" className={styles.itemRow}>
                <span className={styles.label}>会员卡号</span>
                <span className={styles.value}>{cardCodeValue}</span>
              </Flex>
              {(cardPassword || newUserPassValue) && (
                <Flex justify="between" align="start" className={styles.itemRow}>
                  <span className={styles.label}>会员密码</span>
                  <span className={styles.value}>{cardPassword || newUserPassValue}</span>
                </Flex>
              )}
              {(payPassword || newPayPassword) && (
                <Flex justify="between" align="start" className={styles.itemRow}>
                  <span className={styles.label}>会员支付密码</span>
                  <span className={styles.value}>{payPassword || newPayPassword}</span>
                </Flex>
              )}
              {realNameValue && (
                <Flex justify="between" align="start" className={styles.itemRow}>
                  <span className={styles.label}>姓名</span>
                  <span className={styles.value} data-handled>{realNameValue}</span>
                </Flex>
              )}
              {(registerTimeValue || newRegisterTime) && (
                <Flex justify="between" align="start" className={styles.itemRow}>
                  <span className={styles.label}>创建时间</span>
                  <span className={styles.value}>{registerTimeValue || newRegisterTime}</span>
                </Flex>
              )}
            </div>
            <div className={styles.spacer}></div>
          </div>
          {footer.map((item, index) => {
            return (
              <CommonBtn
                key={index}
                title={item.text}
                className={item.className}
                onClick={item.onPress}
              />
            );
          })}
        </Flex>
      </Modal>
    );
  }

  render() {
    return <React.Fragment>{this.renderUserModal()}</React.Fragment>;
  }
}

module.exports = CardOpenTip;



// WEBPACK FOOTER //
// ./src/widget/CardOpenTip/index.js